import { DecimalField } from 'components/form'
import React from 'react'

import { FactoryResultadoExameEspecificoFieldProps } from '../../model'
import { getResultadoExameEspecificoProperties } from '../../util'

export const ResultadoExameMarcadoresBioquimicosDecimalField = (props: FactoryResultadoExameEspecificoFieldProps) => {
  const { name, exame } = props

  const { maxLength, precision } = getResultadoExameEspecificoProperties(exame)

  return (
    <DecimalField
      name={name}
      maxLength={maxLength}
      precisao={precision}
      placeholder='Clique para inserir o resultado...'
    />
  )
}
